// minRoll — «подкрутка» костей бота его уровнем бонуса и давлением на лидера
// (см. getBotD6MinRoll, getBotCombatD6MinRoll): бросок равновероятен в
// диапазоне [minRoll, 6].
// rollBonus — прибавка к выпавшему значению (см. getBotD6RollBonus),
// результат не выше 6.
// Случайное число берется ровно одно при любых подкрутках: на этом держатся
// парные прогоны ботов на общих сидах.
// По умолчанию (и для всех реальных игроков всегда) — честный d6
export const getD6Roll = (minRoll = 1, rollBonus = 0) => {
  const safeMinRoll = Math.min(6, Math.max(1, minRoll));
  const roll = safeMinRoll + Math.floor(Math.random() * (7 - safeMinRoll));
  return Math.min(6, roll + Math.max(0, rollBonus || 0));
}